import { Injectable } from '@angular/core';
import { LocalizationOptions } from './models';

@Injectable({
  providedIn: 'root',
})
export class LocalizationOptionsService {
  #localizationConfigs: LocalizationOptions = null;

  getInstance(): LocalizationOptions {
    return this.#localizationConfigs;
  }

  setLocalizationConfigs(configs: LocalizationOptions) {
    this.#localizationConfigs = configs;
  }
}
